import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export const Logo = ({ className = '', linkClassName = '' }) => {
  const { language } = useLanguage();
  const logoSrc = `${process.env.PUBLIC_URL}/brand/logo.svg`;

  return (
    <Link
      to={`/${language}`}
      className={`inline-flex items-center ${linkClassName}`}
      data-testid="logo-link"
      aria-label="ProceSSSurge"
    >
      <img
        src={logoSrc}
        alt="ProceSSSurge"
        className={`block w-auto ${className}`}
        draggable={false}
      />
    </Link>
  );
};
